import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

export default class GalleryController {
    static mount(): void {
        if (document.querySelectorAll("[data-cm-gallery]").length === 0) {
            return;
        }

        const prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;

        GLightbox({
            selector: "[data-cm-gallery] a.glightbox",
            touchNavigation: true,
            loop: true,
            moreText: "Mehr anzeigen",
            openEffect: prefersReducedMotion ? "none" : "zoom",
            closeEffect: prefersReducedMotion ? "none" : "zoom",
        });
    }
}
